<template>
  <b-container class="mt-4 mb-4">
    <b-card :sub-title="subTitle" :title="title" class="cardStyle">
      <b-form @submit.prevent="createUser">
        <b-form-group id="first-name" label="First Name:" label-for="first-name">
          <b-input
            id="first-name"
            v-model="form.firstName"
            :disabled="submitted"
            required
          ></b-input>
        </b-form-group>
        <b-form-group id="last-name" label="Last Name:" label-for="last-name">
          <b-input id="last-name" v-model="form.lastName" :disabled="submitted" required></b-input>
        </b-form-group>
        <b-form-group id="email" label="Email address:" label-for="email">
          <b-input
            id="email"
            v-model="form.email"
            :disabled="submitted"
            required
            type="email"
          ></b-input>
        </b-form-group>
        <b-form-group id="exostar-id" hidden label="Exostar ID:" label-for="exostar-id">
          <b-input id="exostar-id" v-model="form.exostarId" :disabled="submitted"></b-input>
        </b-form-group>

        <b-button
          v-if="!submitted"
          :disabled="loading"
          class="float-right"
          type="submit"
          variant="primary"
          >{{ buttonText }}
          <div v-if="loading" style="display: inline;">
            <b-spinner small></b-spinner>
            <span class="sr-only">Loading...</span>
          </div>
        </b-button>
      </b-form>

      <thank-you v-if="submitted" :title="'Email validation is required'">
        <template #description>Please check your email to continue with your request.</template>
        <template #icon>
          <b-icon class="h2 mb-0" icon="exclamation-circle" variant="warning" />
        </template>
      </thank-you>
    </b-card>
  </b-container>
</template>

<script>
  import AnonymousFormSelectStudySite from './AnonymousFormSelectStudySite.vue';
  import ThankYou from '../../common/ThankYou.vue';

  export default {
    name: 'AnonymousForm',
    components: { AnonymousFormSelectStudySite, ThankYou },
    props: ['user', 'exostarId'],
    data() {
      return {
        loading: false,
        submitted: false,
        title: 'Pfizer Application Access Manager',
        subTitle:
          'To get started with account request(s) for you or your site staff, please add your full name and email address below. You will then receive an email from noreply@pfizer.com. Please be sure to check your spam folder. The email will have a link to the Pfizer Application Access Manager. Upon clicking the link which expires after 12 hours, you will be directed to a page to add the study and site ID and begin your request(s). ',
        form: {
          firstName: null,
          lastName: null,
          email: null,
          exostarId: null,
          isSipUser: false,
        },
      };
    },
    computed: {
      buttonText() {
        if (this.submitted) {
          return 'Submitted';
        }
        return 'Submit';
      },
    },
    created() {
      if (this.exostarId) {
        this.form.exostarId = this.exostarId;
        this.form.isSipUser = true;
      }
    },
    methods: {
      createUser() {
        this.loading = true;
        axios
          .post('/api/anonymous-user', this.form)
          .then(r => {
            if (r.status === 200) {
              this.submitted = true;
              this.loading = false;
              if (this.form.isSipUser) {
                this.$store.commit('setUserDetails', r.data.user);
                this.$router.push({
                  path: `/anonymous-form/select-study-site?${r.data.parts.query}`,
                });
              }
            }
          })
          .catch(e => {
            console.error(e);
            if (e.response.status === 403) {
              this.toast('Access Denied', 'Please refresh or grab a new link from SIP', 'danger');
            } else {
              this.toast('Error', 'Something went wrong, please try again later', 'danger');
            }
            this.submitted = false;
            this.loading = false;
          });
      },
      toast(title, message, variant) {
        this.$bvToast.toast(message, {
          title: title,
          variant: variant,
          solid: true,
        });
      },
    },
  };
</script>

<style scoped></style>
